import {ReactElement, useEffect, useState} from "react";
import * as css from "./styles/vz-two-button-group.module.scss";
import {Button} from "@zendeskgarden/react-buttons";


interface VZTwoButtonGroupProps {
    fieldLabel: string;
    firstLabel: string;
    secondLabel: string;
    defaultIsFirstOptionSelected?: boolean;
    inline?: boolean;
    onChange: (isFirstOptionSelected: boolean) => void;
}

/**
 * Gives user two options they can toggle between, similar to the deprecated zendesk button group https://zendeskgarden-v8.netlify.app/components/button-group
 * which had issues last time I tried to use it in our project
 */
export default function VZTwoButtonGroup({fieldLabel, firstLabel, secondLabel, defaultIsFirstOptionSelected, inline, onChange}: VZTwoButtonGroupProps): ReactElement {
    const [isFirstSelected, setIsFirstSelected] = useState(defaultIsFirstOptionSelected ?? true);

    useEffect(() => {
        onChange(isFirstSelected);
    }, [isFirstSelected]);

    return (
        <div className={`${css.vzTwoButtonGroup} ${inline === true && css.inline}`}>
            <span className={css.label}>{fieldLabel}</span>
            <div className={css.buttons}>
                <Button
                    size="small"
                    isPrimary={isFirstSelected}
                    onClick={() => setIsFirstSelected(true)}
                    aria-label={`select option: ${firstLabel}`}
                >
                    {firstLabel}
                </Button>
                <Button
                    size="small"
                    isPrimary={!isFirstSelected}
                    onClick={() => setIsFirstSelected(false)}
                    aria-label={`select option: ${secondLabel}`}
                >
                    {secondLabel}
                </Button>
            </div>
        </div>
    );
}
